export const rules = {
  rules: 'Rules',
  add: 'Add rule',
  noRules: 'No rules',
  createFirstRule: 'Create the first rule',
  deleteRuleTitle: 'Are you sure you want to delete this rule?',
  deletedSuccess: 'Rule deleted',
  editRule: 'Edit rule',
  deleteRule: 'Delete rule',
  displayRule: 'Display rule',
  previewRule: 'Preview rule',
  filterPlaceholder: 'Filter by',
  filterPlaceholderText: 'Filter by type',
  manageRulesPara:
    'Edit, delete or add rules. Rules allow you to dynamically control the visibility of options and the behavior of the model based on parameters selected by the user.',
  filters: {
    all: 'All',
    option: 'Option',
    group: 'Group',
    step: 'Step',
    full: 'Full phrase',
  },
} as const
